import { useEffect, useMemo, useState } from "react";
import { api, BACKEND_URL } from "@/lib/api";
import { PageHeader, CopyButton } from "@/components/shared";
import { Input } from "@/components/ui/input";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { snippets } from "@/pages/merchant/snippets";

export default function Integration() {
  const [keys, setKeys] = useState([]);
  const [sites, setSites] = useState([]);
  const [p, setP] = useState({ amount: "49.90", currency: "EUR", ref: "CMD-1001", returnUrl: "" });
  const [pk, setPk] = useState("");
  const [domain, setDomain] = useState("");

  useEffect(() => {
    api.get("/merchant/api-keys").then((r) => { setKeys(r.data); const first = r.data.find((k) => k.kind === "pk" && !k.revoked); if (first) setPk(first.public_key); });
    api.get("/merchant/sites").then((r) => { setSites(r.data); if (r.data[0]) setDomain(r.data[0].domain); });
  }, []);

  const ctx = useMemo(() => ({ ...p, pk: pk || "pk_test_VOTRE_CLE", domain: domain || "votre-site.com", base: BACKEND_URL, returnUrl: p.returnUrl || `https://${(domain || "votre-site.com").replace("*.", "www.")}/merci` }), [p, pk, domain]);
  const code = useMemo(() => snippets(ctx), [ctx]);

  return (
    <div>
      <PageHeader title="Générateur d'intégration" subtitle="Snippets prêts à copier avec votre clé publique et votre domaine pré-remplis. La création de commande sensible se fait côté serveur avec la clé secrète : l'Origin seul n'est pas une garantie absolue." />
      <div className="panel p-5 grid grid-cols-2 lg:grid-cols-6 gap-3 mb-6">
        <select value={pk} onChange={(e) => setPk(e.target.value)} className="h-9 rounded-md border border-input bg-background px-3 text-sm font-mono col-span-2" data-testid="snippet-pk-select">
          <option value="">Clé publique…</option>{keys.filter((k) => k.kind === "pk" && !k.revoked).map((k) => <option key={k.id} value={k.public_key}>{k.public_key} ({k.mode})</option>)}
        </select>
        <select value={domain} onChange={(e) => setDomain(e.target.value)} className="h-9 rounded-md border border-input bg-background px-3 text-sm font-mono" data-testid="snippet-domain-select">
          <option value="">Domaine…</option>{sites.map((s) => <option key={s.id} value={s.domain}>{s.domain}</option>)}
        </select>
        <Input value={p.amount} onChange={(e) => setP({ ...p, amount: e.target.value })} placeholder="Montant" data-testid="snippet-param-amount" />
        <select value={p.currency} onChange={(e) => setP({ ...p, currency: e.target.value })} className="h-9 rounded-md border border-input bg-background px-3 text-sm" data-testid="snippet-param-currency"><option>EUR</option><option>USD</option><option>BTC</option></select>
        <Input value={p.ref} onChange={(e) => setP({ ...p, ref: e.target.value })} placeholder="Référence" data-testid="snippet-param-ref" />
      </div>
      <Tabs defaultValue="html">
        <TabsList className="bg-zinc-900 border border-border" data-testid="snippet-lang-tabs">
          {Object.keys(code).map((k) => <TabsTrigger key={k} value={k} data-testid={`snippet-tab-${k}`}>{code[k].label}</TabsTrigger>)}
        </TabsList>
        {Object.entries(code).map(([k, v]) => (
          <TabsContent key={k} value={k}>
            <p className="text-xs text-zinc-400 mb-2">{v.desc}</p>
            <div className="relative">
              <pre className="bg-[#0D0D11] border border-zinc-800 rounded-lg p-4 text-xs font-mono text-zinc-200 overflow-x-auto leading-relaxed" data-testid="snippet-code-block">{v.code}</pre>
              <div className="absolute top-3 right-3"><CopyButton value={v.code} label="Snippet copié" testId="copy-snippet-btn" className="bg-zinc-900 border border-zinc-700 rounded px-2 py-1" /></div>
            </div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}
